<!--
    描述：拖拽组件 --- 示例说明
    时间：2020-10-14
    Created by ws
-->
<template>
	<div>123</div>
</template>

<script>
export default {
	data() {
		return {
			splitV1: 0.5,
			splitV2: 0.4,
			splitV3: 0.4,
			splitV4: 0.5
		}
	},
	methods: {}
}
</script>

<style scoped lang="less">
.border-box {
	border: 1px solid #bed2ea;
	padding: 5px 10px;
	height: 250px;
}

.pd0 {
	padding: 0;
}
</style>
